import { useState, useEffect, useRef, useContext } from "react";
import React from "react";
import profileHam from "../../assets/profileHam.svg";
import closeNav from "../../assets/closeNav.svg";
import okayGoLogoNav from "../../assets/okayGoLogoNav.svg";
import ogId from "../../assets/ogId.svg";
import userPhoneNo from "../../assets/userPhoneNo.svg";
import forwardIcon from "../../assets/forwardIcon.svg";
import forwardIconBlue from "../../assets/forwardIconBlue.svg";
import logoutIcon from "../../assets/logoutIcon.svg";
import { MyContext } from "../../context/Context";
import defaultImg from "../../assets/defaultImg.svg";

export default function Navbar() {
  const {
    isNavbarVisible,
    setIsNavbarVisible,
    workerDetails,
    setWorkerDetails,
  } = useContext(MyContext);
  const [navOpen, setNavOpen] = useState(false);
  const [remainingHeight, setRemainingHeight] = useState(0);
  const navRef = useRef(null); // For referencing the navbar height
  const [navData, setNavData] = useState({});

  const handleLogout = () => {
    localStorage.clear(); // Clear local storage
    window.location.href = "/login"; // Redirect to /login
  };

  const handleNavToggle = () => {
    setNavOpen((prev) => !prev); // Toggle the navOpen state
  };

  // Adding event listener to detect route changes without refresh
  const handleRouteChange = () => {
    const newPath = window.location.pathname.replace(/\/$/, "");
    if (
      newPath === "/login" ||
      newPath === "/password" ||
      newPath === "/create-password" ||
      newPath === "/otp-verify" ||
      newPath === "/forgot-password"
    ) {
      setIsNavbarVisible(false);
    } else {
      setIsNavbarVisible(true);
    }
  };

  useEffect(() => {
    const phone = localStorage.getItem("phone");
    const name = localStorage.getItem("name");
    const ogId = localStorage.getItem("ogId");
    // const profilePhoto = localStorage.getItem("profilePhoto"); // if the photo is null save defaultImg in local
    let profilePhoto = localStorage.getItem("profilePhoto");

    // If profilePhoto is null or undefined, save defaultImg in localStorage
    if (!profilePhoto) {
     localStorage.setItem("profilePhoto", ""); 
     profilePhoto = localStorage.getItem("profilePhoto");
    }
    setNavData({
      phone,
      name,
      ogId,
      profilePhoto,
    });
  }, []);

  useEffect(() => {
    // Calculate the remaining height when the nav is open
    const handleResize = () => {
      if (navRef.current) {
        const navHeight = navRef.current.offsetHeight;
        setRemainingHeight(window.innerHeight - navHeight);
      }
    };

    handleResize(); // Initial calculation
    window.addEventListener("resize", handleResize); // Update on resize

    // Disable scroll when nav is open
    if (navOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      window.removeEventListener("resize", handleResize);
      document.body.style.overflow = "auto"; // Reset scroll behavior when unmounted
    };
  }, [navOpen]);

  useEffect(() => {
    const currentPath = window.location.pathname.replace(/\/$/, "");
    setWorkerDetails(JSON.parse(localStorage.getItem("userData")));

    // Check if current path is one of the specified paths
    if (
      currentPath === "" ||
      currentPath === "/login" ||
      currentPath === "/password" ||
      currentPath === "/create-password" ||
      currentPath === "/otp-verify" ||
      currentPath === "/forgot-password"
    ) {
      setIsNavbarVisible(false);
    } else {
      setIsNavbarVisible(true);
    }

    window.addEventListener("popstate", handleRouteChange);

    // Clean up listener on component unmount
    return () => {
      window.removeEventListener("popstate", handleRouteChange);
    };
  }, []);

  const navOpenLayout = (
    <section className="absolute w-full grid h-full bg-white">
      <section className="flex justify-between items-center p-4 shadow-sm bg-white">
        <div>
          <img src={okayGoLogoNav} alt="OkayGo-Logo" />
        </div>
        <div onClick={handleNavToggle} className="cursor-pointer">
          <img src={closeNav} alt="CloseIcon" />
        </div>
      </section>
      <section className="cursor-pointer w-full flex items-center py-[22px] px-4 gap-5 border-b border-gray-200 bg-white">
        <div className="overflow-hidden rounded-full w-[60px] h-[60px] bg-slate-100">
          <img
            src={
              defaultImg
            }
            alt="profile-Image"
          />
        </div>
        <div className="grid gap-1">
          <div className="text-sm">{workerDetails?.name || navData.name}</div>
          <div className="flex items-center gap-[14px]">
            <div className="flex items-center text-[#757575] text-[12px] gap-[6px]">
              <img src={ogId} alt="Icon" />
              {workerDetails?.ogId || navData.ogId}
            </div>
            <div className="flex items-center text-[#757575] text-[12px] gap-[6px]">
              <img src={userPhoneNo} alt="Icon" />
              {workerDetails?.phone || navData.phone}
            </div>
          </div>
        </div>
      </section>
      <section
        className={`${
          window.location.pathname.replace(/\/$/, "") === "/task-page"
            ? "text-[#1C75BC]"
            : ""
        } p-4 pb-3 pt-[28px] w-full flex items-center justify-between bg-white`}
      >
        <a href="/task-page">
          <div className="text-[14px]">My Tasks</div>
        </a>
        <a href="/task-page" className="grid place-items-center">
          {window.location.pathname.replace(/\/$/, "") === "/task-page" ? (
            <img src={forwardIconBlue} alt="Forward-Icon" />
          ) : (
            <img src={forwardIcon} alt="" />
          )}
        </a>
      </section>
      <section
        className={`${
          window.location.pathname.replace(/\/$/, "") === "/mark-attendance"
            ? "text-[#1C75BC]"
            : ""
        } p-4 py-3 w-full flex items-center justify-between bg-white`}
      >
        <a href="/mark-attendance">
          <div className="text-[14px]">My Attendance</div>
        </a>
        <a href="/mark-attendance" className="grid place-items-center">
          {window.location.pathname.replace(/\/$/, "") ===
          "/mark-attendance" ? (
            <img src={forwardIconBlue} alt="Forward-Icon" />
          ) : (
            <img src={forwardIcon} alt="" />
          )}
        </a>
      </section>
      <section className="w-full p-4 bg-white shadow-xl">
        <div
          onClick={handleLogout}
          className="flex items-center w-fit bg-[#F2F2F2] rounded-full p-2 gap-[6px]"
        >
          <div>
            <img src={logoutIcon} alt="Logout-icon" />
          </div>
          <div className="text-black text-[14px]">Logout</div>
          <div className="grid items-center">
            <img src={forwardIcon} alt="" />
          </div>
        </div>
      </section>
      <div
        className="bg-gray-400 opacity-50"
        style={{ height: remainingHeight + "px" }}
      ></div>
    </section>
  );

  const navCloseLayout = (
    <section className="w-full p-4 py-3 flex justify-between items-center">
      <div className="flex items-center gap-3">
        <div onClick={handleNavToggle} className="relative cursor-pointer">
          <div className="overflow-hidden rounded-full w-7 h-7 bg-slate-100 cursor-pointer">
            <img
              src={
                defaultImg
              }
              alt=""
            />
          </div>
          <div
            className={`${
              navOpen ? "hidden" : ""
            } rounded-full absolute bottom-0 right-0 opacity-65`}
          >
            <img src={profileHam} alt="" />
          </div>
        </div>
        <div className="text-[16px] font-medium">
          {window.location.pathname.replace(/\/$/, "") === "/task-page"
            ? "My Tasks"
            : window.location.pathname.replace(/\/$/, "") === "/mark-attendance"
            ? "My Attendance"
            : ""}
        </div>
      </div>
    </section>
  );

  return (
    isNavbarVisible && (
      <section
        ref={navRef}
        className={`w-full bg-white ${
          navOpen ? "relative h-full " : ""
        } sticky top-0 shadow z-50 transition-all duration-300 ease-in-out`}
      >
        {!navOpen ? navCloseLayout : navOpenLayout}
      </section>
    )
  );
}
